import { css } from "@/utils/css";

type Props = React.HTMLProps<HTMLDivElement> & {
    children?: React.ReactNode;
};

export function Section({ children, className = "", ...props }: Props) {
    return (
        <div className={css(className, "section p-5 rounded-2")} {...props}>
            {children}
        </div>
    );
}
